import request from '@/utils/request';
import { newHost } from '@/global-config';

// eslint-disable-next-line import/prefer-default-export
export function queryLiquidationDocList(data) {
  return request({
    url: '/merchantFranchisee/list',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

// eslint-disable-next-line import/prefer-default-export
export function downLoadLiquidationDoc(data) {
  return request({
    url: '/merchantFranchisee/download',
    method: 'get',
    data,
    baseURL: newHost,
  });
}
